import React from 'react';
import { Button, Image, Link, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CartIcon } from '../../utils/icons/cart';
import { ChartIcon } from '../../utils/icons/chart';
import { PaperIcon } from '../../utils/icons/paper';
import { useGameColorsProvider } from '../../providers/Theme/gameColorsProvider';
import { PlayCircleIcon } from '../../common/components/icons/play_circle';
import { useLocation } from 'react-router-dom';
import { disabledGames } from 'src';

const ButtonBody = ({ children, ...props }: { children: React.ReactNode } | any) => {
	return (
		<Button
			fontWeight="600"
			fontSize="12px"
			lineHeight="15px"
			variant="unstyled"
			width="100%"
			borderRadius="4px"
			boxSizing="border-box"
			textTransform="uppercase"
			display="flex"
			gridGap="12px"
			alignItems="center"
			background="white"
			{...props}
		>
			{children}
		</Button>
	);
};

export const ButtonBuy = ({ isVariantSmall = false, ...props }: { isVariantSmall?: boolean } & any) => {
	const { t } = useTranslation();
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();
	const location = useLocation();

	const isDisabled = !!location.pathname?.toString()?.includes(disabledGames[0]);

	return (
		<Tooltip label={isDisabled ? 'You cannot buy this game anymore.' : ''}>
			<ButtonBody
				background={callToActionColor}
				_hover={{ background: callToActionColor }}
				color={callToActionTextColor}
				isDisabled={isDisabled}
				{...props}
			>
				{isVariantSmall || <Text>{t('purchasePane.buy').toString()}</Text>}
				<CartIcon color={callToActionTextColor} />
			</ButtonBody>
		</Tooltip>
	);
};

export const ButtonPlay = ({ gameRef, ...props }: { gameRef?: string } | any) => {
	const { t } = useTranslation();
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();

	const navigateToGameAsset = () => {
		// @ts-ignore
		window.open(gameRef, '_blank').focus();
	};

	return (
		<ButtonBody
			background={callToActionColor}
			color={callToActionTextColor}
			onClick={navigateToGameAsset}
			{...props}
		>
			<Text>{t('gameOverview.play').toString()}</Text>
			<PlayCircleIcon />
		</ButtonBody>
	);
};

export const ButtonChart = () => {
	const { t } = useTranslation();
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();
	return (
		<ButtonBody
			background={callToActionColor}
			border={`2px solid ${callToActionColor}`}
		>
			<Text color={callToActionTextColor}>{t('purchasePane.chart').toString()}</Text>
			<ChartIcon color={callToActionTextColor} />
		</ButtonBody>
	);
};

export const ButtonGamePaper = ({ gamePaperUri }: { gamePaperUri: string }) => {
	const { t } = useTranslation();
	const { callToActionColor, textColor } = useGameColorsProvider();
	return (
		<ButtonBody
			border={`2px solid ${callToActionColor}`}
			as={Link}
			background="none"
			_hover={{ background: callToActionColor, textDecoration: 'none' }}
			href={gamePaperUri}
		>
			<Text>{t('purchasePane.paper').toString()}</Text>
			<PaperIcon color={textColor} />
		</ButtonBody>
	);
};
